import React from 'react';
import PropTypes from 'prop-types';
import { useOptions } from './OptionsContext';
import { domClasses } from '../player/dom';

function SyncMiniPlayerState({ player }) {
  const { mini } = useOptions();

  React.useEffect(() => {
    if (mini) {
      player.wrapperElement.classList.add(domClasses.miniPlayer);
    } else {
      player.wrapperElement.classList.remove(domClasses.miniPlayer);
    }

    player._aspectratioService?.updateAspectRatio();
  }, [mini]);

  return null;
}
SyncMiniPlayerState.propTypes = {
  player: PropTypes.object.isRequired,
};

export default React.memo(SyncMiniPlayerState);
